/*
* This file handle reducer's state for all actions that are related to company
*/
import _ from 'lodash';

const initialState = {
  messeageToSupport: false,
  companyUpdate: false,
  isSendingToSupport: false,
  isSupportError: false,
  sendCancelDokkitMail: false,
  openSubscriptionPopup: false,
  disableaSupportButton: false,
  disableCancelDokkitMailButton: false,


  companyTemplateSetRequesting: false,
  companyTemplateSet : [],

  newTemplateForm: {
    submitting : false,
    errors : {}
  }
};

export default function jobs(state = initialState, action) {
  switch(action.type) {
    case 'SEND_SUPPORT_MESSAGE_REQUEST':
      return Object.assign({}, state, {
        isSendingToSupport: true,
        disableaSupportButton: true
      });
    case 'SEND_SUPPORT_MESSAGE_REQUEST_SUCCESS':
      return Object.assign({}, state, {
        isSendingToSupport: false,
        messeageToSupport: true,
        disableaSupportButton: false,
        isSupportError: false,
      });
    case 'SEND_SUPPORT_MESSAGE_REQUEST_FAILURE':
      return Object.assign({}, state, {
        isSendingToSupport: false,
        isSupportError: true,
        disableaSupportButton: false
      });
    case 'SEND_CHANGE_MESSAGE_SENT_STATUS_REQUEST':
      return Object.assign({}, state, {
        messeageToSupport: false,
        openSubscriptionPopup: false
      });
    case 'RESET_SUPPORT_POPUP':
      return Object.assign({}, state, {
        isSendingToSupport: false,
        isSupportError: false,
        messeageToSupport: false,
        companyUpdate: false,
        openSubscriptionPopup: false
      });
    case 'EDIT_COMPANY_PIC_REQUEST_SUCCESS':
      return Object.assign({}, state, {
        companyUpdate: true
      });
    case 'EDIT_COMPANY_SUCCESS':
      return Object.assign({}, state, {
        companyUpdate: true
      });
    case 'Unset_Company_Edit_Flag':
      return Object.assign({}, state, {
        companyUpdate: false
      });
    case 'SEND_CANCEL_DOKKIT_MESSAGE_REQUEST':
      return Object.assign({}, state, {
        disableCancelDokkitMailButton: true
      });
    case 'SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_SUCCESS':
      return Object.assign({}, state, {
        sendCancelDokkitMail: true,
        disableCancelDokkitMailButton: true
      });
    case 'SEND_CANCEL_DOKKIT_REQUEST_MESSAGE_FAILURE':
      return Object.assign({}, state, {
        disableCancelDokkitMailButton: true
      });
    case 'OPEN_SUPPORT_POPUP':
      return Object.assign({}, state, {
        openSubscriptionPopup: true
      });
    case 'SEND_CANCEL_DOKKIT_REQUEST_SUCCESS':
      window.localStorage.removeItem('agl-token');
      window.localStorage.removeItem('agl-username');
      window.localStorage.removeItem('temp_company_id');
      window.localStorage.removeItem('temp_user_id');
      window.localStorage.removeItem('userType');
      return state;


    case 'GET_TEMPLATE_SET_REQUEST':
      return Object.assign({}, state, {
        companyTemplateSetRequesting: true,
        // companyTemplateSet : []
      });
    case 'GET_TEMPLATE_SET_SUCCESS':
      return Object.assign({}, state, {
        companyTemplateSetRequesting: false,
        companyTemplateSet: action.response.template_set
      });
    case 'GET_TEMPLATE_SET_FAILURE':
      return Object.assign({}, state, {
        companyTemplateSetRequesting: false
      });

    case 'SAVE_TEMPLATE_SET_REQUEST':
      return Object.assign({}, state, {
        newTemplateForm: {... state.newTemplateForm, submitting: true, errors : {}}
      });

    case 'SAVE_TEMPLATE_SET_SUCCESS':
    
      return Object.assign({}, state, {
        companyTemplateSet: [...state.companyTemplateSet, action.response.newTmpSet.setInfo],
        newTemplateForm: {... state.newTemplateForm, submitting: false, errors : {}}
      });

    case 'SAVE_TEMPLATE_SET_FAILURE': 
      return Object.assign({}, state, {
        newTemplateForm: {... state.newTemplateForm, submitting: false, errors : action.payload.error}
      });


   case 'SEND_REMOVE_MANUAL_REQUEST_SUCCESS':

      const tmpSetId = action.tmpSetId            
      var  companyTemplateSet = [...state.companyTemplateSet];
      let findKey =  _.findKey(companyTemplateSet, function(o) { return o._id ===  tmpSetId})
      if(findKey !== undefined) {

        let selectedManuals = companyTemplateSet[findKey]['selectedManuals']
        delete selectedManuals[action.groupName]

        companyTemplateSet[findKey] = {
            ...companyTemplateSet[findKey],
            selectedManuals : selectedManuals
        }
      }
      return {
          ...state,
          companyTemplateSet
      }

   case 'DELETE_TEMPLATE_SET_SUCCESS': {

     const tmpSetId = action.tmpSetId     
      let  companyTemplateSet = [...state.companyTemplateSet];
      companyTemplateSet = _.filter(companyTemplateSet, function(o) { return o._id !==  tmpSetId})

      return {
          ...state,
          companyTemplateSet : [...companyTemplateSet]
      }
   }

      

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/company.js